/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import tagHelper from '../../../helpers/tag_helper';

function JobCategoryPicker(props) {
  const { id, onChange, options, placeholder, selectedOptions } = props;

  const formattedOptions = options.map((b) => ({
    value: b.value,
    label: b.value,
    tag: { type: 'job' },
  }));

  const pickerStyles = {
    option: (provided) => ({
      ...provided,
      fontSize: 14,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 14,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'var(--neutral-600)',
      fontWeight: 'normal',
    }),
    multiValue: (styles, { data }) => {
      const tagColor = tagHelper.tagColor(data.tag);

      return {
        ...styles,
        backgroundColor: tagColor,
        color: 'white',
      };
    },
    multiValueLabel: (styles) => ({
      ...styles,
      color: 'white',
    }),
  };
  const initialValue = selectedOptions.map((x) => {
    const existingOption = formattedOptions.find((o) => o.value === x);

    return existingOption || { value: x, label: x };
  });

  const noOptionsMessage = ({ inputValue }) => (
    <strong>
      No categories found for
      {` "${inputValue}" `}
    </strong>
  );

  return (
    <Form.Group className='tag-picker'>
      <Select
        id={id}
        classNamePrefix='tag-picker'
        value={initialValue}
        options={formattedOptions}
        isMulti
        placeholder={placeholder}
        onChange={onChange}
        styles={pickerStyles}
        noOptionsMessage={noOptionsMessage}
        aria-label='Select a Job Category'
      />
    </Form.Group>
  );
}

JobCategoryPicker.defaultProps = {
  placeholder: 'Select tags',
  options: [],
  selectedOptions: [],
};

JobCategoryPicker.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  placeholder: PropTypes.string,
  selectedOptions: PropTypes.arrayOf(PropTypes.any),
};

function JobCategoryPickerFallback() {
  return <Form.Group />;
}

export default exportWithBoundary(JobCategoryPicker, JobCategoryPickerFallback);
